export enum InfantSessionStorageKeys {
    infantCustomerNumber = 'infantCustomerNumber',
}